// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3BQjr","errors":"Errors_errors__37hjD"};